import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import MenuItem from './MenuItem';
import MoreMenuContent from './MoreMenuContent';
import moreSvg from '../icon-list/raw-icons/more.svg';
import Popover from '../popover';

const MoreMenu = (props) => {
  const [isSelected, setIsSelected] = useState(false);
  const {
    toggleExitAssignmentModal,
    toggleSubmitConfirmDialog,
    moreButtonRef,
    onLineReaderClick,
    isPreviewPlayer,
    toggleHelpModal,
    onReferenceSheetClick,
    onCalculatorClick,
    onAnnotationClick,
  } = props;

  const onMoreMenuClose = useCallback(() => {
    moreButtonRef?.current?.close();
    setIsSelected(false);
    // Adding timeout because the button aria expanded attribute does not gets updated when reader reads the button state
    setTimeout(() => {
      moreButtonRef?.current?.focus();
    }, 0);
  });

  const onMoreMenuOpen = useCallback(() => {
    setIsSelected(true);
  });

  return (
    <Popover
      hideArrow
      closeOnBackwardsFocus
      position="bottom-end"
      onClose={onMoreMenuClose}
      onOpen={onMoreMenuOpen}
      tabindex="-1"
      trigger={
        <MenuItem
          label="More"
          icon="more"
          ref={moreButtonRef}
          containerClass="bb-mobile:hidden"
          selected={isSelected}
        >
          <img
            aria-hidden="true"
            alt="More icon"
            src={moreSvg}
            className="bb-mobile:w-10 bb-mobile:h-10"
          />
        </MenuItem>
      }
      className="relative !block"
    >
      <MoreMenuContent
        isPreviewPlayer={isPreviewPlayer}
        openExitAssignmentModal={toggleExitAssignmentModal}
        openSubmitConfirmDialog={toggleSubmitConfirmDialog}
        openHelpModal={toggleHelpModal}
        onLineReaderClick={onLineReaderClick}
        data-test-id="more-menu-content"
        data-cy="more-menu-content"
        onReferenceSheetClick={onReferenceSheetClick}
        onCalculatorClick={onCalculatorClick}
        onAnnotationClick={onAnnotationClick}
      />
    </Popover>
  );
};

MoreMenu.propTypes = {
  toggleExitAssignmentModal: PropTypes.func,
};

MoreMenu.defaultProps = {
  toggleExitAssignmentModal: () => {},
};

export default MoreMenu;
